/* ============================================================================
   ZARWANA — PDP logic. Reads the product handle from /products/<handle>.
   ========================================================================== */
(async function () {
  const $ = (s, r = document) => r.querySelector(s);
  await ZARWANA.ready;

  const pathMatch = location.pathname.match(/\/products\/([^/?#]+)/);
  const handle = pathMatch ? decodeURIComponent(pathMatch[1]) : new URLSearchParams(location.search).get("id");
  const p = ZARWANA.byId(handle);
  if (!p) {
    document.querySelector("[data-pdp]").innerHTML =
      '<p style="padding:60px 0;text-align:center;color:var(--text-mute)">' +
      "This product isn't available — it may have been removed. " +
      '<a href="/collections/all" style="text-decoration:underline">Back to catalog</a></p>';
    return;
  }
  let qty = 1;

  document.title = `${p.name} — Zarwana`;
  ZRecent.push(p.id);

  /* ---------- gallery: every photo uploaded for this product in Shopify --
     One large stage photo with a rail of small thumbnails on its left — the
     photos must never stack into a page-long scroll. The stage is a <button>,
     not a <div>: inspecting a stone is the core job of a jewellery PDP, so
     the frame is genuinely interactive and has to be reachable by keyboard. */
  const gallery = $("[data-gallery]");
  const photos = (p.images && p.images.length ? p.images : [p.img]);
  let active = 0;
  gallery.classList.toggle("has-thumbs", photos.length > 1);
  gallery.innerHTML = `
    ${photos.length > 1 ? `
    <div class="g-thumbs" role="group" aria-label="Product photos">
      ${photos.map((url, i) => `
        <button class="g-thumb${i ? "" : " is-active"}" type="button"
                aria-label="Show photo ${i + 1} of ${photos.length}"
                ${i ? "" : 'aria-current="true"'} data-thumb="${i}">
          <img src="${ZARWANA.imgUrl(url, 240)}" alt="" loading="lazy" /></button>`).join("")}
    </div>` : ""}
    <button class="g-item g-stage" type="button" aria-expanded="false"
            aria-label="Enlarge photo">
      <img src="${ZARWANA.imgUrl(photos[0], 1200)}" alt="${p.name}" data-stage-img /></button>`;
  const stage = $(".g-stage", gallery);
  const stageImg = $("[data-stage-img]", gallery);

  function setActive(i) {
    if (i === active) return;
    active = i;
    releaseZoom();
    gallery.querySelectorAll(".g-thumb").forEach((t, ti) => {
      t.classList.toggle("is-active", ti === i);
      if (ti === i) t.setAttribute("aria-current", "true");
      else t.removeAttribute("aria-current");
    });
    /* fade out, swap once the new photo has arrived, fade back in */
    const url = ZARWANA.imgUrl(photos[i], 1200);
    stageImg.classList.add("is-swapping");
    const pre = new Image();
    pre.onload = pre.onerror = () => {
      if (active !== i) return; /* a later click already superseded this one */
      stageImg.src = url;
      stageImg.alt = `${p.name} — photo ${i + 1}`;
      stageImg.classList.remove("is-swapping");
    };
    pre.src = url;
  }

  /* ---------- click to inspect ------------------------------------------
     The zoom opens FROM the point clicked (transform-origin follows the
     pointer), so the detail under the cursor is the detail that grows.
     Keyboard activation has no coordinates, so it falls back to centre. */
  let zoomed = null;
  function releaseZoom() {
    if (!zoomed) return;
    zoomed.classList.remove("is-zoomed");
    zoomed.setAttribute("aria-expanded", "false");
    zoomed = null;
  }
  gallery.addEventListener("click", (e) => {
    const thumb = e.target.closest(".g-thumb");
    if (thumb) { setActive(+thumb.dataset.thumb); return; }
    const item = e.target.closest(".g-item");
    if (!item) return;
    if (item === zoomed) { releaseZoom(); return; }
    releaseZoom();
    const r = item.getBoundingClientRect();
    /* e.clientX is 0 for keyboard-triggered clicks; centre is the sane default */
    const hasPoint = e.clientX || e.clientY;
    item.style.setProperty("--ox", hasPoint ? `${((e.clientX - r.left) / r.width) * 100}%` : "50%");
    item.style.setProperty("--oy", hasPoint ? `${((e.clientY - r.top) / r.height) * 100}%` : "50%");
    item.classList.add("is-zoomed");
    item.setAttribute("aria-expanded", "true");
    zoomed = item;
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") releaseZoom(); });
  document.addEventListener("click", (e) => { if (!e.target.closest(".g-item")) releaseZoom(); });

  /* ---------- hover lens -------------------------------------------------
     A magnifier square rides the cursor and paints the detail under it at
     2.5x, from a 1600px asset so the inside of the square is sharper than
     the base image. Hover-capable fine pointers only: phones have no hover,
     so they keep click-to-inspect above. While a frame is click-zoomed the
     transform math no longer matches the laid-out rect, so the lens hides
     (CSS) and stops tracking (the guard below). */
  if (matchMedia("(hover: hover) and (pointer: fine)").matches) {
    const LENS = 190, MAG = 2.5;
    const lens = document.createElement("span");
    lens.className = "g-lens";
    lens.setAttribute("aria-hidden", "true");
    stage.append(lens);
    let lensFor = -1;
    /* the sharp asset is a second download, so fetch it on first approach —
       and again whenever the stage has swapped to a different photo */
    stage.addEventListener("pointerenter", () => {
      if (lensFor !== active) {
        lens.style.backgroundImage = `url("${ZARWANA.imgUrl(photos[active], 1600)}")`;
        lensFor = active;
      }
    });
    stage.addEventListener("pointermove", (e) => {
      if (stage.classList.contains("is-zoomed")) return;
      const r = stage.getBoundingClientRect();
      const h = LENS / 2;
      /* clamp the square inside the photo; near an edge the lens stops
         following but keeps magnifying the true edge region */
      const x = Math.min(Math.max(e.clientX - r.left, h), Math.max(r.width - h, h));
      const y = Math.min(Math.max(e.clientY - r.top, h), Math.max(r.height - h, h));
      lens.style.transform = `translate(${x - h}px, ${y - h}px)`;
      lens.style.backgroundSize = `${r.width * MAG}px ${r.height * MAG}px`;
      lens.style.backgroundPosition = `${h - x * MAG}px ${h - y * MAG}px`;
    });
  }

  /* ---------- buy box ---------------------------------------------------- */
  $("[data-p-name]").textContent = p.name;
  $("[data-p-price]").innerHTML = ZARWANA.priceHTML(p);
  if (p.compareAt > p.price) {
    const note = document.createElement("div");
    note.className = "pdp-sale-note";
    note.textContent = ZARWANA.SALE.label + " applied";
    $("[data-p-price]").insertAdjacentElement("afterend", note);
  }
  /* Rich description straight from Shopify admin's editor (merchant-authored
     content, same trust model as every Shopify theme); plain-text fallback
     when a product has no formatted description. */
  if (p.descHtml) $("[data-p-desc]").innerHTML = p.descHtml;
  else if (p.desc) $("[data-p-desc]").textContent = p.desc;
  else $("[data-p-desc]").closest("details").remove();
  $("[data-p-size]").innerHTML = p.sizes.map((s) => `<option>${s}</option>`).join("");
  $("[data-p-purity]").innerHTML = p.purities.map((s) => `<option>${s}</option>`).join("");

  /* ring size (rings + toe rings only) — recorded as a line-item property so
     it reaches the order and its notification emails */
  const wantsRingSize = ZARWANA.needsRingSize(p);
  if (wantsRingSize) {
    $("[data-p-ringsize]").innerHTML =
      '<option value="">Select size</option>' +
      ZARWANA.RING_SIZES.map((s) => `<option>${s}</option>`).join("");
    $("[data-ringsize-block]").hidden = false;
  }
  const ringSizeProps = () => {
    if (!wantsRingSize) return null;
    const size = $("[data-p-ringsize]").value;
    if (!size) { ZToast("Please select a ring size."); return undefined; }
    return { "Ring Size": size };
  };

  const wishBtn = $("[data-p-wish]");
  const syncWish = () => (wishBtn.textContent = ZWish.has(p.id) ? "Saved to Wishlist ✓" : "Add to Wishlist");
  syncWish();
  wishBtn.addEventListener("click", () => { ZWish.toggle(p.id); syncWish(); });

  $("[data-p-share]").addEventListener("click", async () => {
    try {
      if (navigator.share) await navigator.share({ title: p.name, url: location.href });
      else { await navigator.clipboard.writeText(location.href); ZToast("Link copied to clipboard"); }
    } catch { /* user dismissed */ }
  });

  $("[data-breakup]").addEventListener("click", () => {
    ZToast("Prices are shown as MRP. Your invoice includes the required purchase details.");
  });

  /* qty stepper */
  const qtyEl = $("[data-qty]");
  $("[data-qty-dec]").addEventListener("click", () => { qty = Math.max(1, qty - 1); qtyEl.textContent = qty; });
  $("[data-qty-inc]").addEventListener("click", () => { qty += 1; qtyEl.textContent = qty; });

  /* purchase actions — resolve the chosen size/purity to a real Shopify variant */
  const currentVariant = () => ZARWANA.findVariant(p, $("[data-p-size]").value, $("[data-p-purity]").value);
  const addBtn = $("[data-add-cart]");
  const buyBtn = $("[data-buy-now]");
  if (p.soldOut) {
    addBtn.textContent = "Sold out";
    addBtn.disabled = true;
    buyBtn.disabled = true;
  } else {
    addBtn.addEventListener("click", async () => {
      const variant = currentVariant();
      if (!variant) { ZToast("That combination isn't available."); return; }
      const props = ringSizeProps();
      if (props === undefined) return; // ring size required but not chosen
      addBtn.disabled = true;
      const ok = await ZCart.add(variant.id, qty, props);
      addBtn.disabled = false;
      if (ok) { ZToast("Added to your bag"); ZOverlay.open("cart"); }
    });
    buyBtn.addEventListener("click", async () => {
      const variant = currentVariant();
      if (!variant) { ZToast("That combination isn't available."); return; }
      const props = ringSizeProps();
      if (props === undefined) return; // ring size required but not chosen
      buyBtn.disabled = true;
      const ok = await ZCart.add(variant.id, qty, props);
      buyBtn.disabled = false;
      if (ok) location.href = ZCart.checkoutUrl();
    });
  }

  /* ---------- related: same collection first, then the rest ------------- */
  const related = [
    ...ZARWANA.byCollection(p.collection).filter((x) => x.id !== p.id),
    ...ZARWANA.products.filter((x) => x.collection !== p.collection && x.id !== p.id),
  ].slice(0, 8);
  $("[data-related]").innerHTML = related.map((x) => ZCard(x)).join("");
  ZCarousel($("[data-related-wrap]"));

  ZReveal();
})();
